import { MouseEvent, FC } from 'react';

import styles from './Curtain.module.scss';

type Props = {
  handleClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const Curtain: FC<Props> = ({ handleClick }) => {
  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (handleClick) {
      handleClick(event);
    }
  };

  return (
    <button className={styles.curtain} onClick={handleButtonClick}>
      <div className={styles.bg}></div>
      <div className={styles.inner}>
        <div className={styles.curtainImage}>
          {/* メイン画像 */}
          <img
            src={require(`components/parts/Curtain/images/main.webp`)}
            alt={`コードF15 ODYSSEY 幸せの風吹く空への道しるべ`}
          />
        </div>
        <p className={styles.curtainText}>画面をタップでスタート</p>
      </div>
    </button>
  );
};
